import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

export const useSite = () =>
  useQuery({
    queryKey: ["site-content"],
    queryFn: async () => (await api.get("/content/site")).data,
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });

export const FALLBACK_SETTINGS = {
  companyName: "LogiTech Nexus",
  email: "info@logitechnexus.com",
  addressLine1: "6731 N 17th St",
  addressLine2: "Tacoma, WA 98406-1901",
  addressCountry: "United States",
  projectTypes: ["Custom Software", "Web Application", "SaaS Platform", "Business Automation", "System Integration", "AI / Automation", "Other"],
  budgetOptions: ["Under $10k", "$10k – $25k", "$25k – $50k", "$50k – $100k", "$100k+", "Not sure yet"],
  timelineOptions: ["As soon as possible", "1–3 months", "3–6 months", "6+ months", "Flexible"],
};
